// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    padding: 0;
    margin: 0;
    font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
    background-color: #fff;
}

.hidden {
    display: none !important;
}

.view-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.ms-welcome__header {
    padding: 20px;
    padding-bottom: 30px;
    background-color: #f3f2f1;
    position: relative;
}

.ms-welcome__main {
    padding: 20px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
}

/* Forms */
.ms-TextField {
    margin-bottom: 15px;
    width: 100%;
}

.ms-Label {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
}

.ms-TextField-field {
    box-sizing: border-box;
    margin: 0;
    box-shadow: none;
    border: 1px solid #605e5c;
    border-radius: 2px;
    font-weight: 400;
    font-size: 14px;
    color: #323130;
    height: 32px;
    padding: 0 8px;
    width: 100%;
    outline: none;
}

.ms-TextField-field:focus {
    border-color: #0078d4;
}

.ms-TextField-field--multiline {
    height: auto;
    padding: 6px 8px;
    resize: vertical;
}

/* Buttons */
.ms-Button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #0078d4;
    color: white;
    border: none;
    padding: 8px 20px;
    cursor: pointer;
    min-width: 80px;
    font-size: 14px;
    margin-top: 10px;
    width: 100%;
}

.ms-Button:hover {
    background-color: #106ebe;
}

.ms-Button--small {
    padding: 4px 10px;
    font-size: 12px;
    min-width: auto;
    width: auto;
}

.ms-Button--icon {
    background-color: transparent;
    color: #333;
    padding: 5px;
    min-width: auto;
    width: auto;
}

.ms-Button--icon:hover {
    background-color: #edebe9;
    color: #000;
}

.error-message {
    color: #a4262c;
    margin-top: 5px;
}

/* Cell Picker */
.cell-picker-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
}

.cell-picker-wrapper .ms-TextField-field {
    flex: 1;
}

.btn-pick-cell {
    background: #f3f2f1;
    border: 1px solid #605e5c;
    border-radius: 2px;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 14px;
    height: 32px;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-pick-cell:hover {
    background: #edebe9;
}

.btn-pick-cell.picking {
    background: #0078d4;
    color: white;
    border-color: #0078d4;
}

/* Context Section */
.context-section {
    background: #f8f8f8;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 10px;
}

.context-section .ms-TextField {
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,4IAA4I;IAC5I,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["body {\n    padding: 0;\n    margin: 0;\n    font-family: \"Segoe UI\", \"Segoe UI Web (West European)\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif;\n    background-color: #fff;\n}\n\n.hidden {\n    display: none !important;\n}\n\n.view-container {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.ms-welcome__header {\n    padding: 20px;\n    padding-bottom: 30px;\n    background-color: #f3f2f1;\n    position: relative;\n}\n\n.ms-welcome__main {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n}\n\n/* Forms */\n.ms-TextField {\n    margin-bottom: 15px;\n    width: 100%;\n}\n\n.ms-Label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 600;\n}\n\n.ms-TextField-field {\n    box-sizing: border-box;\n    margin: 0;\n    box-shadow: none;\n    border: 1px solid #605e5c;\n    border-radius: 2px;\n    font-weight: 400;\n    font-size: 14px;\n    color: #323130;\n    height: 32px;\n    padding: 0 8px;\n    width: 100%;\n    outline: none;\n}\n\n.ms-TextField-field:focus {\n    border-color: #0078d4;\n}\n\n.ms-TextField-field--multiline {\n    height: auto;\n    padding: 6px 8px;\n    resize: vertical;\n}\n\n/* Buttons */\n.ms-Button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background-color: #0078d4;\n    color: white;\n    border: none;\n    padding: 8px 20px;\n    cursor: pointer;\n    min-width: 80px;\n    font-size: 14px;\n    margin-top: 10px;\n    width: 100%;\n}\n\n.ms-Button:hover {\n    background-color: #106ebe;\n}\n\n.ms-Button--small {\n    padding: 4px 10px;\n    font-size: 12px;\n    min-width: auto;\n    width: auto;\n}\n\n.ms-Button--icon {\n    background-color: transparent;\n    color: #333;\n    padding: 5px;\n    min-width: auto;\n    width: auto;\n}\n\n.ms-Button--icon:hover {\n    background-color: #edebe9;\n    color: #000;\n}\n\n.error-message {\n    color: #a4262c;\n    margin-top: 5px;\n}\n\n/* Cell Picker */\n.cell-picker-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.cell-picker-wrapper .ms-TextField-field {\n    flex: 1;\n}\n\n.btn-pick-cell {\n    background: #f3f2f1;\n    border: 1px solid #605e5c;\n    border-radius: 2px;\n    padding: 4px 8px;\n    cursor: pointer;\n    font-size: 14px;\n    height: 32px;\n    min-width: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-pick-cell:hover {\n    background: #edebe9;\n}\n\n.btn-pick-cell.picking {\n    background: #0078d4;\n    color: white;\n    border-color: #0078d4;\n}\n\n/* Context Section */\n.context-section {\n    background: #f8f8f8;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    padding: 12px;\n    margin-bottom: 10px;\n}\n\n.context-section .ms-TextField {\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
